export const COLUNA_TIPO = "Tipo";
export const COLUNA_ID = "ID";
export const COLUNA_DESCRICAO = "Descrição";
export const COLUNA_STATUS = "Status";
export const TIPO_ROTULO = { SERVICO: "Serviço", MATERIAL: "Material" } as const;
